import { useCallback, useMemo } from 'react'

import Cookies from 'js-cookie'

import { AuthAPI } from 'api'
import config from 'config'
import { INVITE_CODE_COOKIE } from 'constants/Cookies'
import {
  GOOGLE_REDIRECT_URI,
  MICROSOFT_REDIRECT_URI,
} from 'layouts/SignUpStep/constants'

/***
 * Hook that exchanges third party tokens for user's data
 *
 * @returns {object} { acceptGoogleInvitation: (token) => void, acceptMicrosoftInvitation: (token) => void }
 */
export const useAcceptThirdPartyInvite = () => {
  const corePayload = useMemo(
    () => ({
      authToken: Cookies.get(INVITE_CODE_COOKIE),
      clientId: config.DEFAULT_CLIENT_ID,
      anonymousId:
        !!window.analytics && !!window.analytics.user
          ? window.analytics.user().anonymousId()
          : 'none',
    }),
    []
  )

  const acceptGoogleInvitation = useCallback(
    (token) =>
      AuthAPI.post('/google/oauth/invitation/accept', {
        ...corePayload,
        redirectUri: GOOGLE_REDIRECT_URI,
        code: token,
      }),
    [corePayload]
  )
  const acceptMicrosoftInvitation = useCallback(
    (token) =>
      AuthAPI.post('/microsoft/oauth/invitation/accept', {
        ...corePayload,
        redirectUri: MICROSOFT_REDIRECT_URI,
        code: token,
      }),
    [corePayload]
  )

  return useMemo(
    () => ({ acceptGoogleInvitation, acceptMicrosoftInvitation }),
    [acceptGoogleInvitation, acceptMicrosoftInvitation]
  )
}

export default useAcceptThirdPartyInvite
